import path from "path";
import { logDebug } from "../utils";
import { InstrumentHooks } from "./instruments/hooks";
import { LinuxPerf } from "./linux_perf/linux_perf";
interface NativeCore {
  InstrumentHooks: InstrumentHooks;
  LinuxPerf: typeof LinuxPerf;
}

interface NativeCoreWithBindingStatus extends NativeCore {
  isBound: boolean;
}

let native_core: NativeCoreWithBindingStatus;
try {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const nativeCore = require("node-gyp-build")(
    path.dirname(__dirname),
  ) as NativeCore;
  native_core = {
    ...nativeCore,
    isBound: true,
  };
} catch (e) {
  logDebug("Failed to bind native core, instruments will not work.");
  logDebug(e);
  native_core = {
    LinuxPerf: class LinuxPerf {
      start() {
        return false;
      }
      stop() {
        return false;
      }
    },
    InstrumentHooks: {
      isInstrumented: () => {
        return false;
      },
      startBenchmark: () => {
        return 0;
      },
      stopBenchmark: () => {
        return 0;
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      setExecutedBenchmark: (_pid: number, _uri: string) => {
        return 0;
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      setIntegration: (_name: string, _version: string) => {
        return 0;
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      setEnvironment: (_sectionName: string, _key: string, _value: string) => {
        return 0;
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      writeEnvironment: (_pid: number) => {
        return 0;
      },
      currentTimestamp: () => {
        return 0n;
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      addMarker: (_pid: number, _markerType: number, _timestamp: bigint) => {
        return 0;
      },
      __codspeed_root_frame__: <T>(callback: () => T): T => {
        return callback();
      },
      // Mirror of core.h's marker types for the no-native-binding fallback.
      MARKER_TYPE_SAMPLE_START: 0,
      MARKER_TYPE_SAMPLE_END: 1,
      MARKER_TYPE_BENCHMARK_START: 2,
      MARKER_TYPE_BENCHMARK_END: 3,
    },
    isBound: false,
  };
}

export default native_core;
